import React from 'react';
import Footer from '../Components/Footer';
import Header from '../Components/Header';
import SubmitArea from '../Components/SubmitArea';

const ContactUs = () => {
    return (
        <div>
            <Header/>
            <SubmitArea/>
            <Footer/>
        </div>
    );
};

export default ContactUs;